import React, {useEffect, useMemo, useRef, useState} from "react";
import {getPagina, getPaginasShopperByShopperSlug, getProductsShopperBySearch, getShopper} from "../../api/shopper";
import {useParams} from "react-router-dom";
import {ButtonDownload} from "../../components/ButtonDownload";
import ProductShopperCard from "../../components/products/ProductShopperCard";
import {Button, Col, Form, InputGroup, Modal, Row} from "react-bootstrap";
import styles from './Shopper.module.css';
import CarruselShopper from "../../components/shoppers/CarruselShopper";
import {toStringMesTextoFromFechaCompletoFromString} from "../../utils/fecha";
import ModalTutorial from "../../components/modals/ModalTutorial";
import {getCookie, setCookie, TUTORIAL_VISTO} from "../../utils/cookies";
import SearchPNG from "../../images/Search.png";
import Filter from "../../components/filter/Filter";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import {ButtonMaximizar} from "../../components/ButtonMaximizar";
import ModalMaximizar from "../../components/modals/ModalMaximizar";
import DOMPurify from "isomorphic-dompurify";

export function Shopper() {

    const {shopperSlug, pageNumber} = useParams();
    const [shopperStrapi, setShopperStrapi] = useState({});
    const [paginasShopperStrapi, setPaginasShopperStrapi] = useState([]);
    const [paginaSeleccionada, setPaginaSelected] = useState();
    const [productos, setProductos] = useState([]);
    const [prodBuscado, setProdBuscado] = useState('');
    const [pagIndex, setPagIndex] = useState(null);
    const [showModalTutorial, setShowModalTutorial] = useState(false)
    const productosRef = useRef(null);
    const [mostrarMas, setMostrarMas] = useState(false)
    const [validated, setValidated] = useState(true);
    const closeModalTutorial = () => {
        setShowModalTutorial(false)
        setCookie(TUTORIAL_VISTO, true)
    }

    const [filtrosSelect, setfiltrosSelect] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const cargarShopper = () => {
        console.log("Buscando shopper con slug:", shopperSlug);
        getShopper(shopperSlug)
            .then(r => {
                console.log("Shopper response:", r.data);
                const shoppers = r.data[0] || r.data?.data?.[0];
                if (!shoppers) {
                    console.warn("No shoppers found con slug:", shopperSlug, "Intentando sin filtro mostrarEnHome...");
                    setShopperStrapi({});
                    return;
                }
                const shopperData = shoppers.attributes || shoppers;
                const filtros = shopperData.filtros;
                shopperData.filtros = filtros ? getFiltersShopper(Array.isArray(filtros) ? filtros : [filtros]) : [];
                setShopperStrapi(shopperData)
                if (!getCookie(TUTORIAL_VISTO)) {
                    const hasVideo = shopperData.video?.iframe !== null && shopperData.video?.iframe !== undefined;
                    setShowModalTutorial(!hasVideo)
                }
                if (window.location.hash){
                    let hash = window.location.hash.slice(1)
                    let element = document.getElementById(hash)
                    if (element){
                        element.scrollIntoView()
                    }
                }
            })
            .catch(e => {
                setShopperStrapi({})
                console.error("Error cargando los datos del shopper", e)
            })
    }

    const getFiltersShopper = (filters) => {

        return filters.map((filter => ({
            nombre: filter.nombre,
            opciones: filter.opciones.map(o => ({nombre: o.nombre ? o.nombre : o, checked: false}))
        })))
    }

    const cargarPaginas = () => {
        getPaginasShopperByShopperSlug(shopperSlug)
            .then(r => {
                console.log("Paginas response:", r.data);
                const paginasData = r.data.data || r.data;
                const paginasArray = Array.isArray(paginasData) ? paginasData : [];
                setPaginasShopperStrapi(paginasArray)
                if (paginasArray.length > 0) {
                    setPaginaSelected(paginasArray[0])
                }
            })
            .catch(e => {
                setPaginasShopperStrapi([])
                console.error("Error cargando las páginas:", e)
            })
    }

    const cargarProductosPagina = () => {
        setProdBuscado('');
        setValidated(false);
        setMostrarMas(false)
        if (paginaSeleccionada) {
            const paginaData = paginaSeleccionada.attributes || paginaSeleccionada;
            const productos = paginaData.productos || [];
            setProductos(productos)
        }
    }

    const cleanProducts = event => {
        //Si el valor buscado es dif al prodBuscado actual el pagIndex vuelve a 0
        if (event.target.value !== prodBuscado) {
            setPagIndex(0);
        }
        setProdBuscado(event.target.value);
        //Si se limpia el cuadro de busqueda se vuelven a cargar los productos de la pagina actual
        if (event.target.value.length == 0) {
            cargarProductosPagina();
        }
    };

    const cargarMas = () => {
        setPagIndex(pagIndex + 4);
    }


    const aplicarFiltros = () => {
        if (pagIndex == 0) {
            cargarProductosBusqueda(filtrosSelect);
        } else {
            setPagIndex(0);
        }
    }

    const cargarProductosBusqueda = (filtrosSelect) => {
        if (prodBuscado.length > 0 || filtrosSelect.length > 0) {
            getProductsShopperBySearch(prodBuscado, shopper.id, filtrosSelect, pagIndex, 4)
                .then(r => {
                    let prodsResult = [];
                    prodsResult = r.data.data;
                    if (pagIndex > 0 && prodsResult.length > 0) {
                        prodsResult.unshift(...productos);
                    }
                    setProductos(prodsResult);
                    setMostrarMas(prodsResult.length !== r.data.pagination.total);
                })
                .catch(e => {
                    setProductos([])
                    console.error("Error cargando los productos", e)
                })

        } else {
            setPagIndex(0);
            cargarProductosPagina();
        }
    }

    useEffect(() => {
        cargarShopper()
    }, [])

    useEffect(() => {
        cargarPaginas()
    }, [])


    useEffect(() => {
        cargarProductosBusqueda(filtrosSelect)
    }, [pagIndex])

    useEffect(() => {
        setProductos([])
        cargarProductosPagina()
    }, [paginaSeleccionada])

    useEffect(() => {
        if (pageNumber && !isNaN(Number(pageNumber)) && paginasShopperStrapi && paginasShopperStrapi.length > 0) {
            const foundPagina = paginasShopperStrapi.find(p => {
                const pData = p.attributes || p;
                return pData.numeroPagina === Number(pageNumber);
            });
            if (foundPagina) {
                seleccionarPagina(foundPagina);
            }
        }
    }, [pageNumber, paginasShopperStrapi])

    const seleccionarPagina = (pagina) => {
        productosRef?.current?.scrollIntoView({block: "start", inline: "nearest"})
        setPaginaSelected(pagina)
    }

    const manageFilterItem = (filter, value) => {
        let filtSeleccionados = [...filtrosSelect];
        let getFilterIndex = filtSeleccionados.findIndex((ad => ad.filtro === filter));
        if (filtSeleccionados[getFilterIndex]) {
            let findOpt = filtSeleccionados[getFilterIndex].seleccionados.find(opt => opt === value);
            if (findOpt) {
                filtSeleccionados[getFilterIndex].seleccionados = filtSeleccionados[getFilterIndex].seleccionados.filter(opt => opt !== value);
                if (filtSeleccionados[getFilterIndex].seleccionados.length == 0) {
                    filtSeleccionados = filtSeleccionados.filter(el => el.filtro !== filter)
                }
            } else {
                filtSeleccionados[getFilterIndex].seleccionados.push(value);
            }
        } else {
            filtSeleccionados.push({filtro: filter, seleccionados: [value]});
        }
        setfiltrosSelect(filtSeleccionados);
    }

    const limpiarFiltros = (filter) => {
        let filtSeleccionados = [...filtrosSelect];
        if (filter === undefined) {
            filtSeleccionados = []
            const shopper = shopperStrapi
            shopper.filtros = getFiltersShopper(shopper.filtros)
            setShopperStrapi(shopper)
            cargarProductosPagina()
        } else {
            filtSeleccionados = filtSeleccionados.filter(el => el.filtro !== filter)
            cargarProductosBusqueda(filtSeleccionados)
        }
        setfiltrosSelect(filtSeleccionados)
    }

    const shopper = Object.keys(shopperStrapi).length > 0 ? {
        id: shopperStrapi.id,
        nombre: shopperStrapi.nombre,
        fechaInicio: shopperStrapi.fechaInicio,
        fechaFinal: shopperStrapi.fechaFinal,
        pdf: shopperStrapi.pdf?.url || shopperStrapi.pdf?.data?.attributes?.url,
        slug: shopperStrapi.slug,
        filtros: shopperStrapi.filtros,
        video: shopperStrapi.video,
        paginas: paginasShopperStrapi,
        legal: shopperStrapi.legal,
        idBotonInterno: shopperStrapi.idBotonInterno,
        idBotonExterno: shopperStrapi.idBotonExterno
    } : {}

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setPagIndex(0);
        setValidated(true);
        cargarProductosBusqueda()
    };

    const onKeyUp = (event) => {
        if (event.charCode === 13) {
            handleSubmit(event)
        }
    }

    const imagenes = useMemo(() => {
        if (shopper && shopper.paginas && Array.isArray(shopper.paginas)) {
            return shopper.paginas.map(p => {
                const pData = p.attributes || p;
                const imagenData = pData.imagen?.data?.attributes?.url || pData.imagen?.url;
                return imagenData;
            }).filter(img => img)
        } else {
            return []
        }
    },[shopper]);

    return (
        <>
            <Breadcrumbs title={shopper.nombre} breadcrumbs={[{text: "Shoppers", link: "/publicaciones"}, {text: shopper.nombre}]}>
                <div>
                    {window.innerWidth < 960 ? <ModalTutorial open={showModalTutorial} onClose={closeModalTutorial}/> : null}
                    {Object.keys(shopper).length > 0 ? <div key={shopper.id}>
                        {shopper.video != null && shopper.video.iframe != null ?
                            <div className={`d-flex flex-column ${styles.iframe}`}>
                                <div className={`${styles.video}`}>
                                    <iframe src={shopper.video.iframe}
                                            scrolling={`no`}
                                            title="YouTube video player"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen/>
                                </div>
                            </div>
                            : null}
                        <div id={`un-universo-de-diversion`}
                            className={`${shopper.video != null && shopper.video.iframe != null ? 'pb-4' : 'p-4'} d-sm-inline-block d-md-inline-flex w-100 justify-content-between ${styles.header}`}>
                            <div className={"align-self-center"}>
                                <div
                                    className={`color-dark-blue fs-5`}>{`Válido del ${toStringMesTextoFromFechaCompletoFromString(shopper.fechaInicio)}
                                    al ${toStringMesTextoFromFechaCompletoFromString(shopper.fechaFinal)}`}</div>
                            </div>
                            <div className={`d-flex gap-2`}>
                                <div className={`align-self-end`}>
                                    <ButtonMaximizar onClick={() => { setShowModal(true); }} />
                                    <ModalMaximizar show={showModal} onHide={()=>setShowModal(!showModal)} imagenes={imagenes}/>
                                </div>
                                <div className={`align-self-end`}>
                                    <ButtonDownload shopper={shopper} interno/>
                                </div>
                            </div>
                        </div>
                        <CarruselShopper paginas={shopper.paginas} numberPage={pageNumber} setPaginaSelected={seleccionarPagina}/>
                        <div ref={productosRef} className={`my-5 mx-3 mx-md-5 ${styles.containerProductos}`}>
                            <div className={`py-5 container-md`}>
                                <div className={`d-md-flex flex-wrap align-items-center justify-content-between`}>
                                    {shopper.filtros.length ?
                                        <>
                                            {shopper.filtros.map(filtro => {
                                                return (
                                                    <Filter filter={filtro} manageFilterItem={manageFilterItem}
                                                            aplicarFiltros={aplicarFiltros}
                                                            limpiarFiltrosProps={limpiarFiltros}/>
                                                )
                                            })}
                                            <div className={`d-flex align-items-center justify-content-center my-4`}>
                                                <a onClick={() => limpiarFiltros()} className={styles.cleanFilters}>Limpiar
                                                    filtros</a>
                                            </div>
                                        </>
                                        : null}
                                    <div className={`d-flex ${styles.input} justify-content-center`}>
                                        <Form noValidate validated={validated} onSubmit={handleSubmit} className={styles.form}>
                                            <InputGroup>
                                                <Form.Control required
                                                              className={`${styles.inputSearch}`}
                                                              placeholder='Buscar en este shopper'
                                                              onChange={cleanProducts}
                                                              onKeyPress={onKeyUp}
                                                              value={prodBuscado}>
                                                </Form.Control>
                                                <div className={`${styles.searchIconContainer}`}>
                                                    <span className="material-symbols-outlined material-symbols-button fs-4 align-middle">search</span>
                                                </div>
                                            </InputGroup>
                                            <Form.Control.Feedback type="invalid">
                                                Ingresa un criterio de búsqueda.
                                            </Form.Control.Feedback>
                                        </Form>
                                    </div>
                                </div>
                                <Row>
                                    {productos.length > 0 ? productos.map(producto => (
                                        <Col key={producto.id} className={` px-md-2 py-3`} md={6}>
                                            <ProductShopperCard productoStrapi={producto}
                                                                shopper={shopper}/>
                                        </Col>
                                    )) : null}
                                </Row>
                                {productos.length > 0 ? mostrarMas ?
                                        <div className={`text-center my-5`}>
                                            <Button className={styles.btnMore} onClick={cargarMas}>Mostrar más
                                                resultados</Button>
                                        </div>
                                        : null
                                    : null}

                                {productos.length < 1 ?
                                    <div className={`text-center my-5 m-auto ${styles.notFound}`}>
                                        <p className={`text-center`}>
                                            ¡Oops! El artículo que buscas no se encuentra disponible, <br
                                            className={'d-none d-md-block'}/>prueba
                                            con otro nombre, o descubre más opciones en <span
                                            className={styles.linkOthers}><a>nuestro catálogo.</a></span></p>
                                    </div>
                                    : null}
                                <div className={`fs-7 py-5`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(shopper.legal) }} />
                            </div>
                        </div>
                    </div> : null}
                </div>
            </Breadcrumbs>
        </>

    );
}

export default Shopper
